import { Controller } from '@hotwired/stimulus';
import {
  subscribeCustomEvent,
  unsubscribeCustomEvent,
} from '@frontend/utils/events';

export default class extends Controller {
  static targets = ['progressIndicator', 'content'];

  connect() {
    if (!this.hasContentTarget || !this.hasProgressIndicatorTarget)
      return false;

    this.boundUpdateMeasure = this.updateMeasure.bind(this);
    this.boundUpdateProgress = this.updateProgress.bind(this);
    this.boundHandleUpdate = this.handleUpdate.bind(this);

    document.body.addEventListener('resize', this.boundUpdateMeasure, {
      passive: true,
    });
    document.body.addEventListener('scroll', this.boundUpdateProgress, {
      passive: true,
    });
    this.intervalId = window.setInterval(this.update.bind(this), 5000);
    subscribeCustomEvent(
      'article-reading-progress:update',
      this.boundHandleUpdate
    );
    this.update();
  }

  disconnect() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
    }

    if (this.boundUpdateMeasure) {
      document.body.removeEventListener('resize', this.boundUpdateMeasure);
    }
    if (this.boundUpdateProgress) {
      document.body.removeEventListener('scroll', this.boundUpdateProgress);
    }
    if (this.boundHandleUpdate) {
      unsubscribeCustomEvent(
        'article-reading-progress:update',
        this.boundHandleUpdate
      );
    }
  }

  handleUpdate() {
    this.update();
  }

  update() {
    this.updateMeasure();
    this.updateProgress();
  }

  updateMeasure() {
    this.articleHeight = this.contentTarget.getBoundingClientRect().height;
    this.viewportHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );
  }

  updateProgress() {
    const scrollOffsetY =
      window.pageYOffset || document.documentElement.scrollTop;
    let currentProgress = 0;
    if (scrollOffsetY > this.contentTarget.offsetTop - this.viewportHeight) {
      const scrolledDistance =
        (scrollOffsetY - this.contentTarget.offsetTop + this.viewportHeight) /
        this.articleHeight;
      currentProgress = Number.parseInt(scrolledDistance * 100);
    }
    this.progressIndicatorTarget.style.width = currentProgress.toString() + '%';
  }
}
